import React from 'react';
import { useTranslation } from 'react-i18next';
import { ANDROID_URL, APK_URL, IOS_URL, getDownloadOptions, detectMobilePlatform } from '../utils/mobileAppLinks';
import useApkInfo from '../hooks/useApkInfo';
import './invite-download-links.css';

export default function InviteDownloadLinks() {
    const { t } = useTranslation('invite');
    const { isAndroid, isApple } = detectMobilePlatform();
    const options = getDownloadOptions();
    const apk = useApkInfo();
    const showApk = options.apk && apk.available;

    return (
        <div className="invite-download-links">
            {isAndroid && (
                <>
                    <a
                        href={ANDROID_URL}
                        target="_blank"
                        rel="noreferrer"
                        className="invite-download-btn invite-download-btn--android"
                    >
                        📱 {t('downloadForAndroid')}
                    </a>
                    <p className="invite-download-hint">{t('androidVpnHint')}</p>
                    {showApk && (
                        <a href={APK_URL} download className="invite-download-btn invite-download-btn--android">
                            ⬇️ {t('downloadApkForAndroid')}
                        </a>
                    )}
                </>
            )}

            {isApple && (
                <>
                    <a
                        href={IOS_URL}
                        target="_blank"
                        rel="noreferrer"
                        className="invite-download-btn invite-download-btn--ios"
                    >
                        🍎 {t('downloadForIOS')}
                    </a>
                    <p className="invite-download-hint">{t('iosTestFlightHint')}</p>
                </>
            )}

            {!isAndroid && !isApple && (
                <div className="invite-download-desktop">
                    <p>{t('downloadDesktop')}</p>
                    <a href={ANDROID_URL} target="_blank" rel="noreferrer">
                        📱 {t('downloadAndroidShort')}
                    </a>
                    {showApk && (
                        <>
                            {' · '}
                            <a href={APK_URL} download>
                                ⬇️ {t('downloadApkShort')}
                            </a>
                        </>
                    )}
                    {' · '}
                    <a href={IOS_URL} target="_blank" rel="noreferrer">
                        🍎 {t('downloadIOSShort')}
                    </a>
                </div>
            )}
        </div>
    );
}
